/**
 * SystemNavScrim — 하단 시스템 메뉴 영역(제스처바·3버튼 내비)을 하단탭과 같은
 * 유리 재질로 덮는 전역 가림막. RootLayout 이 1회 렌더한다.
 * 동작·의도 상세는 SystemNavScrim.module.css 주석 참조.
 */
import styles from "./SystemNavScrim.module.css";

export default function SystemNavScrim() {
  return <div className={styles.scrim} aria-hidden="true" />;
}
